import { LazyLoadUtils } from "../../utils/index.js";

export const loadHomeSection = (brandId, clientProvider) => {
  return LazyLoadUtils.lazyWithFallback(
    () =>
      import(
        /* webpackChunkName: "[request]" */
        `../Brands/${brandId}/${clientProvider}/HomeSection.layout.js`
      ),
    { componentName: "loadHomeSection" }
  );
};

export const preload = ({ clientProvider, brandId }) => {
  loadHomeSection(brandId, clientProvider)?.preload();
};
